import { render } from "./mQuality.vue?vue&type=template&id=6cb5a762&scoped=true"
import script from "./mQuality.vue?vue&type=script&lang=js"
export * from "./mQuality.vue?vue&type=script&lang=js"

import "./mQuality.vue?vue&type=style&index=0&id=6cb5a762&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb5a762"]])

export default __exports__